import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';



import { FileRendererComponent } from './file-renderer.component';
import { PipesModule } from "../../../pipes/pipes.module";
import { ProgressSpinnerModule } from "../../default/progress-spinner/progress-spinner.module";
import { FilePipesModule } from "../../../pipes/files/file-pipes.module";
import { ImageFullSpaceModule } from "../../../directives/image-full-space/image-full-space.module";
import { VideoBetterThumbModule } from "../../../directives/video-better-thumb/video-better-thumb.module";

@NgModule({
	declarations: [FileRendererComponent],
    imports: [
        CommonModule,
        MatIconModule,
        VideoBetterThumbModule,
        ImageFullSpaceModule,
        PipesModule,
        TranslateModule,
        PipesModule,
        FilePipesModule,
        ProgressSpinnerModule,
        PipesModule
    ],
	exports: [FileRendererComponent]
})
export class FileRendererModule { }
